import React from "react"
import Card from "react-bootstrap/Card"
import Button from "react-bootstrap/Button"
import localization from "utils/localization"

const ProjectCard = props => {
    const { image, children, link, tools, title, onViewSlide } = props

    return (
        <Card className="project-card-view">
            <Card.Img variant="top" src={ image } alt="card-img" />
            <Card.Body>
                <Card.Title style={{ fontWeight: 'bold' }}>{ title }</Card.Title>
                <Card.Subtitle style={{ fontSize: 13, opacity: .6, marginBottom: 12 }}>{ tools }</Card.Subtitle>
                <Card.Text style={{ textAlign: "justify", fontSize: 14, opacity: .8 }}>
                    { children }
                </Card.Text>
                { link ?
                    <Button variant="primary" href={ link } target="_blank">
                        { localization('learn-more') }
                    </Button> :
                    <Button variant="primary" onClick={ onViewSlide } target="_blank">
                        { localization('view-more') }
                    </Button>
                }
            </Card.Body>
        </Card>
    )
}

export default ProjectCard